module.exports = __webpack_public_path__ + "img/google-new.f95d7699.svg";